import { useEffect, useState } from 'react';

import { forms, directions } from '../../constants';

const useDisplayConfig = values => {
  const [isAppVersion, setAppVersionStatus] = useState(false);
  const [isMaxVersion, setMaxVersionStatus] = useState(false);
  const [isMultiGames, setMultigames] = useState(false);
  const [isServerVersion, setServerVersionStatus] = useState(false);
  const [isAudience, setAudienceStatus] = useState(false);
  const [isСhannel, setChannelStatus] = useState(false);
  const [isEngineVersion, setEngineVersion] = useState(false);
  const [formType, setFormType] = useState(forms.PRODUCT);

  const { direction, eventType } = values;

  useEffect(() => {
    setAppVersionStatus(true);
    setServerVersionStatus(eventType === 'server_release');
    setEngineVersion(eventType === 'engine_release');

    if (!eventType) {
      return setMaxVersionStatus(false);
    }

    if (eventType === 'client_release') {
      setMaxVersionStatus(false);
    } else {
      setMaxVersionStatus(true);
    }

    if (direction === directions.BI) {
      setAppVersionStatus(false);
      const minMaxList = new Set([
        's_tracking_systems',
        's_other_sdk',
        's_server_events',
        's_client_events',
        's_db_project',
        'w_in_out_come',
      ]);
      if (minMaxList.has(eventType)) {
        setMaxVersionStatus(true);
      } else {
        setMaxVersionStatus(false);
      }
    }
    return undefined;
  }, [direction, eventType]);

  useEffect(() => {
    const formTypes = {
      game_product: forms.PRODUCT,
      crm: forms.CRM,
      prod_incident: forms.INCEDENT,
      bi: forms.BI,
    };

    const form = formTypes[direction];

    const isCRM = direction === 'crm';
    const isBI = direction === 'bi';

    setAudienceStatus(isCRM);
    setChannelStatus(isCRM);
    if (isCRM || isBI) {
      setMultigames(true);
    }

    if (form) {
      setFormType(form);
    }
  }, [direction]);

  return {
    isAppVersion,
    isMaxVersion,
    isServerVersion,
    isAudience,
    isСhannel,
    isMultiGames,
    formType,
    isEngineVersion,
  };
};

export default useDisplayConfig;
